module.exports = __webpack_public_path__ + "static/media/reportedGB.a00fd5c8.png";